import { WebcamCapture } from './WebcamCapture'
export default WebcamCapture